import { gql } from "@apollo/client";

export const DeleteAnimatedProducts = gql`
mutation DeleteAnimatedProducts($deleteAnimatedProductsId: ID!) {
  deleteAnimatedProducts(id: $deleteAnimatedProductsId) {
    status
  }
}
`;
